import { render, staticRenderFns } from "./AddUpdateBillApplyShipments.vue?vue&type=template&id=8d71251a&scoped=true"
import script from "./AddUpdateBillApplyShipments.vue?vue&type=script&lang=js"
export * from "./AddUpdateBillApplyShipments.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateBillApplyShipments.vue?vue&type=style&index=0&id=8d71251a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71251a",
  null
  
)

export default component.exports